import './styles.sass';
import { useEffect, useState } from 'react';
import { Alert, Button, CircularProgress, Grid } from '@mui/material';
import { MentorsService } from '../../services';
import { Question } from '../question';
import { Loading } from '../loading';
import { Success } from '../success';
import { getUserData, submitMentorForm, validateResponses } from './helpers';
import { useLocation, useNavigate } from 'react-router-dom';

export const MentorForm = ({ userData = {}, isReview }) => {
  const [saving, setSaving] = useState(false);
  const [required, setRequired] = useState({});
  const [success, setSuccess] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    MentorsService.getQuestions().then(setQuestions).catch(console.error);

    if (location.state) {
      setAnswers(location.state);
    }
  }, []);

  useEffect(() => {
    if (isReview) return;
    if (questions.length) {
      getUserData(questions, setAnswers, userData);
    }
  }, [questions]);

  const onSetResponse = ({ id, question, value }) => {
    setRequired({});
    setAnswers((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        Value: value,
        QuestionID: id,
        QuestionDescription: question,
      },
    }));
  };

  if (success) return <Success />;

  return (
    <Grid className="mentor-questionnaire" container spacing={2}>
      {questions.length ? (
        <>
          {questions.map((question) => (
            <Question
              key={question.ID}
              isReview={isReview}
              question={question}
              onChange={onSetResponse}
              error={required[question.ID]}
              value={answers[question.ID]?.Value || ''}
            />
          ))}
          <Grid className="submit-button" item xs={12}>
            <Button
              disabled={saving}
              variant="contained"
              onClick={() =>
                validateResponses(answers, questions, setRequired, () =>
                  submitMentorForm(
                    answers,
                    setSaving,
                    setSuccess,
                    isReview
                  ).then(() => {
                    if (isReview) {
                      navigate('/admin/mentor/dashboard');
                    }
                  })
                )
              }
            >
              {saving ? <CircularProgress size={25} /> : 'Submit Form'}
            </Button>
          </Grid>
          {Object.keys(required).length ? (
            <Grid item xs={12}>
              <Alert severity="error">
                Please fill out all of the required fields.
              </Alert>
            </Grid>
          ) : null}
        </>
      ) : (
        <Loading />
      )}
    </Grid>
  );
};
